<template>
  <BulletsSlider
    v-if="appendCategory && appendCategory.length"
    v-slot="{ item }"
    :items="appendCategory.filter(category => category.url_key)"
    type="secondary"
    class="flex-1"
    :mobile-screen-attributes="{
      slidesOffsetBefore: 20,
    }"
    :large-screen-attributes="{
      slidesPerView: 'auto',
      slidesOffsetBefore: 0,
    }"
    auto
  >
    <button
      class="w-auto md:w-full px-4 py-8 rounded-2xs flex items-center justify-center"
      :class="{
        'bg-coloration-secondary-100 text-white font-bold': category?.url_key === item.url_key,
        'bg-tertiary-200 text-primary-A900': category?.url_key !== item.url_key,
      }"
      @click="onSelectCategory(item)"
    >
      <span class="uppercase text-lg whitespace-nowrap">
        {{ item.name }}
      </span>
    </button>
  </BulletsSlider>
</template>
<script setup lang="ts">
import type { Category } from '@robustastudio/e-commerce/common';

defineComponent({
  name: 'CategorySlider',
});

const props = defineProps({
  category: {
    type: Object as PropType<Category | null | undefined>,
    default: () => ({}),
  },
  enableAll: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
});

const { t: $t } = useI18n({
  useScope: 'local',
});

const { categories, category: selectedCategory } = useCategorySlider() as {
  categories: Ref<Category[]>;
  category: Ref<Category>;
};

const appendCategory = computed(() => {
  if (props.enableAll)
    return [
      {
        name: $t('all')?.toString(),
        url_key: 'all',
      },
      ...categories.value,
    ];

  return categories.value;
});

/**
 * on mounted set the selected category component to the one injected
 */
onMounted(() => {
  /**
   * set the selected category
   */
  if (!props.category) return;
  selectedCategory.value = props.category;
});

const emit = defineEmits<{
  (e: 'category', url: string): void;
  (e: 'categoryFullData', category: Category | null): void;
}>();

function onSelectCategory(category: Category) {
  if (!(category.url || category.url_key)) {
    return;
  }
  /**
   * set the selected category
   */

  emit('category', `${category.url || category.url_key}`);
  emit('categoryFullData', category);
}
</script>
<i18n>
{
  "en": {
    "all": "All Categories ",
    "categories": "Categories"
  },
  "ar": {
    "all": "الكل",
    "categories": "الاقسام"
  }
}
</i18n>
